import React, { useEffect, useState } from "react";

import { MenuItem, Select, Tooltip, Typography } from "@material-ui/core";
import styled from 'styled-components';
import { Box } from "vqp-common";
import { useStore } from "../../providers/store.provider";
import { Title } from "../orders/details/order/order.style";
import { HelpOutline } from "@material-ui/icons";


const Card = styled(Box)`
    padding: 16px;
    color: ${props => props.theme.colors[props.color]} !important;
    display: flex;
    flex-direction: column;
    align-items: center;
`
const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 15px;
    margin: 15px;
`
const MenuWrapper = styled.div`
    display: flex;
    flex-direction: column;
`

const StoreBaseWrapper = styled.div`
    background-color: orange;
    padding: 0px 8px 0px 16px;
    border-radius: 10px;
    font-size: 14px;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    width: 115px;
    border: 1px solid #000;
    color: #000;
    margin-top: 5px;
`

export const SelectMultistore = () => {


    const storeProvider = useStore();

    const [stores, setStores] = useState([]);
    const [selectedStore, setSelectedStore] = useState("$default")


    useEffect(() => {
        setStores(storeProvider.multistores)
    }, [storeProvider.multistores])

    const selectMultistore = (storeId) => {
        setSelectedStore(storeId)
        storeProvider.setLastSelectedStore(storeId)
    }

    return (
        <Grid>
            <Card>
                <Title>Só mais um passo…</Title>
                <Typography style={{ marginBottom: 12 }}>
                    Selecione uma loja para acessar menus e visualizar as informações e gráficos
                </Typography>
                <Select
                    label={'Selecionar loja'}
                    defaultValue={selectedStore || "$default"}
                    value={selectedStore}
                    onChange={(event) => selectMultistore(event.target.value)}
                >
                    <MenuItem disabled value={"$default"}> Selecionar loja</MenuItem>
                    {stores.map((store, key) => {
                        const { id, name, baseToReplicateItems } = store;
                        return (
                            <MenuItem value={id} key={key}>
                                <MenuWrapper>
                                    <div> {name}</div>
                                    {
                                        baseToReplicateItems &&
                                        <StoreBaseWrapper>
                                            {store.baseToReplicateItems && <span>Loja base</span>}
                                            <Tooltip arrow title={"Loja onde os produtos devem ser criados para a funcionalidade de réplica de produtos e/ou cardápio."}>
                                                <HelpOutline fontSize='small' style={{ color: '#000' }} />
                                            </Tooltip>
                                        </StoreBaseWrapper>
                                    }
                                </MenuWrapper>
                            </MenuItem>
                        );
                    })}
                </Select>
            </Card>
        </Grid>
    )
}